export const progress = [
  {
    name: 'Словниковий запас',
    slug: 'vocabulary_percent',
  },
  {
    name: 'Граматика',
    slug: 'grammar_percent',
  },
  {
    name: 'Майстерність',
    slug: 'mastery_percent',
  },
]

export const styles = {
  track: 'bg-inherit',
  indicator: 'bg-content1-200',
}
